import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const destinationsData = {
  dakar: {
    id: "dakar",
    nom: "Dakar",
    type: "Capitale",
    pays: "Sénégal",
    desc: "Dakar, la capitale vibrante du Sénégal, est une ville qui ne dort jamais. Entre sa corniche spectaculaire, son île historique de Gorée, ses marchés colorés et sa scène gastronomique en plein essor, Dakar est une destination à part entière.",
    img: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1400&q=80",
    population: "3,7 millions",
    langue: "Wolof · Français",
    meteo: "24°C en moyenne",
    meilleurMoment: "Nov — Fév",
    aFaire: [
      "Visiter l'Île de Gorée, patrimoine mondial UNESCO",
      "Se promener sur la Corniche Ouest au coucher du soleil",
      "Explorer le Marché Sandaga et ses artisans locaux",
      "Découvrir le Monument de la Renaissance Africaine",
      "Goûter le thiéboudienne dans un restaurant local",
    ],
  },
  saly: {
    id: "saly",
    nom: "Saly",
    type: "Balnéaire",
    pays: "Sénégal",
    desc: "Saly Portudal, la station balnéaire de référence du Sénégal. Avec ses plages de sable fin, ses resorts et ses eaux turquoise, Saly est le paradis des amateurs de soleil et de détente sur la Petite Côte.",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1400&q=80",
    population: "40 000",
    langue: "Sérère · Français",
    meteo: "26°C en moyenne",
    meilleurMoment: "Nov — Avr",
    aFaire: [
      "Se détendre sur les plages de sable fin de Saly",
      "Pratiquer le kitesurf et les sports nautiques",
      "Visiter les villages de pêcheurs de la Petite Côte",
      "Explorer la Réserve de Bandia et sa faune",
      "Partir en excursion vers le Lac Rose",
    ],
  },
};

// ── Icônes ───────────────────────────────────────────────────
const IconPin = ({ size = 13, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconArrow = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M19 12H5M12 5l-7 7 7 7"/>
  </svg>
);
const IconArrowRight = ({ size = 14, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);
const IconCheck = ({ size = 14, color = "#3D6B2E" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconClock = ({ size = 52, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconThermo = ({ size = 20, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/>
  </svg>
);
const IconCalendar = ({ size = 20, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const IconGlobe = ({ size = 20, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);
const IconUsers = ({ size = 20, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconHome = ({ size = 24, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

// ── Bientôt disponible ────────────────────────────────────────
const BientotSection = ({ titre, desc, icon }) => (
  <div style={{ background: "white", borderRadius: 16, padding: "40px 32px", border: "1.5px solid rgba(28,16,8,.08)", textAlign: "center" }}>
    <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
      <div style={{ width: 72, height: 72, borderRadius: "50%", background: "rgba(196,68,26,.07)", border: "2px dashed rgba(196,68,26,.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {icon}
      </div>
    </div>
    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 700, marginBottom: 8 }}>{titre}</h3>
    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#B8A898", lineHeight: 1.6 }}>{desc}</p>
  </div>
);

export default function DetailDestination() {
  const { id } = useParams();
  const navigate = useNavigate();

  const dest = destinationsData[id];

  // Destination inconnue ou pas encore active
  if (!dest) {
    return (
      <div style={{ fontFamily: "'Fraunces',serif", background: "#FAF5EC", minHeight: "100vh" }}>
        <Navbar transparent={false} />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "80vh", gap: 16, textAlign: "center", padding: "0 5%" }}>
          <div style={{ width: 80, height: 80, borderRadius: "50%", background: "rgba(196,68,26,.08)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 8 }}>
            <IconClock size={40} color="#C4441A" />
          </div>
          <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800 }}>Destination bientôt disponible</h2>
          <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, color: "#7A5A3A", maxWidth: 400 }}>
            Cette destination est en cours de référencement. Revenez bientôt !
          </p>
          <button onClick={() => navigate("/destinations")}
            style={{ background: "#C4441A", color: "white", border: "none", padding: "12px 28px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
            Voir toutes les destinations
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Fraunces',serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }

        .info-pill {
          display: flex; align-items: center; gap: 8px;
          background: rgba(255,255,255,.12); border: 1px solid rgba(255,255,255,.2);
          border-radius: 8px; padding: 10px 14px;
        }

        @keyframes fadeUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .5s ease forwards; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.5} }
        .pulse-clock { animation: pulse 2.5s ease-in-out infinite; }

        .bientot-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }

        @media(max-width:900px) { .bientot-grid { grid-template-columns: 1fr; } }
        @media(max-width:767px) {
          .hero-detail-img { height: 320px !important; }
          .dest-content { padding: 32px 5% 60px !important; }
          .infos-row { flex-wrap: wrap !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      {/* ── BREADCRUMB ── */}
      <div style={{ paddingTop: 68, background: "white", borderBottom: "1px solid rgba(28,16,8,.07)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "14px 5%", display: "flex", alignItems: "center", gap: 8 }}>
          <button onClick={() => navigate("/")} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>Accueil</button>
          <span style={{ color: "#B8A898" }}>›</span>
          <button onClick={() => navigate("/destinations")} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>Destinations</button>
          <span style={{ color: "#B8A898" }}>›</span>
          <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#1C1008", fontWeight: 600 }}>{dest.nom}</span>
        </div>
      </div>

      {/* ── HERO IMAGE ── */}
      <div className="hero-detail-img" style={{ height: 480, position: "relative", overflow: "hidden" }}>
        <img src={dest.img} alt={dest.nom} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(28,16,8,.85) 0%, rgba(28,16,8,.3) 50%, transparent 100%)" }} />

        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "0 5% 36px" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, background: "rgba(196,68,26,.85)", color: "white", padding: "4px 12px", borderRadius: 4, display: "inline-block", marginBottom: 12 }}>
              {dest.type}
            </span>
            <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(32px,6vw,64px)", fontWeight: 800, color: "white", lineHeight: 1.05, letterSpacing: "-2px", marginBottom: 16 }}>
              {dest.nom}
            </h1>
            <div className="infos-row" style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {[
                { icon: <IconThermo size={16} color="rgba(255,255,255,.8)" />, label: dest.meteo },
                { icon: <IconCalendar size={16} color="rgba(255,255,255,.8)" />, label: `Idéal : ${dest.meilleurMoment}` },
                { icon: <IconGlobe size={16} color="rgba(255,255,255,.8)" />, label: dest.langue },
                { icon: <IconUsers size={16} color="rgba(255,255,255,.8)" />, label: dest.population },
              ].map((info, i) => (
                <div key={i} className="info-pill">
                  {info.icon}
                  <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,.85)" }}>{info.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── CONTENU ── */}
      <section className="dest-content" style={{ padding: "48px 5% 80px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>

          {/* Description */}
          <div style={{ maxWidth: 760, marginBottom: 40 }}>
            <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, color: "#7A5A3A", lineHeight: 1.8 }}>
              {dest.desc}
            </p>
          </div>

          {/* À faire */}
          <div style={{ background: "white", borderRadius: 16, padding: "28px 32px", border: "1.5px solid rgba(28,16,8,.07)", marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
              À ne pas manquer à {dest.nom}
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {dest.aFaire.map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                  <div style={{ width: 24, height: 24, borderRadius: "50%", background: "rgba(61,107,46,.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>
                    <IconCheck size={12} color="#3D6B2E" />
                  </div>
                  <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#1C1008", lineHeight: 1.6 }}>{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Bientôt disponible — Hébergements, Transport, Activités */}
          <div style={{ marginBottom: 48 }}>
            <div style={{ marginBottom: 28 }}>
              <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 26, fontWeight: 800, marginBottom: 8 }}>
                Planifiez votre séjour
              </h2>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, color: "#7A5A3A" }}>
                Nos services arrivent progressivement sur cette destination.
              </p>
            </div>

            <div className="bientot-grid">
              <BientotSection
                titre="Hébergements"
                desc="Appartements et villas à {dest.nom} seront disponibles très prochainement. Nos équipes travaillent à référencer les meilleurs logements."
                icon={
                  <div className="pulse-clock">
                    <IconHome size={32} color="#C4441A" />
                  </div>
                }
              />
              <BientotSection
                titre="Transport"
                desc="Location de voitures et transferts disponibles bientôt. Vous pourrez réserver directement avec les prestataires locaux."
                icon={
                  <div className="pulse-clock">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C4441A" strokeWidth="1.8" strokeLinecap="round">
                      <rect x="2" y="7" width="20" height="12" rx="3"/>
                      <path d="M2 11h20"/>
                      <circle cx="7" cy="19" r="2"/>
                      <circle cx="17" cy="19" r="2"/>
                    </svg>
                  </div>
                }
              />
              <BientotSection
                titre="Activités & Loisirs"
                desc="Découvertes culturelles, sports nautiques, gastronomie locale — les activités arrivent prochainement sur cette destination."
                icon={
                  <div className="pulse-clock">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C4441A" strokeWidth="1.8" strokeLinecap="round">
                      <path d="M12 2C8 2 4 6 4 10c0 6 8 12 8 12s8-6 8-12c0-4-4-8-8-8z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                  </div>
                }
              />
            </div>
          </div>

          {/* CTA inscription prestataire */}
          <div style={{ background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)", borderRadius: 18, padding: "36px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 24, flexWrap: "wrap" }}>
            <div>
              <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", marginBottom: 8 }}>
                Vous êtes prestataire à {dest.nom} ?
              </h3>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "rgba(255,255,255,.6)", lineHeight: 1.6 }}>
                Hébergement, transport, activité — inscrivez votre établissement et touchez des milliers de touristes.
              </p>
            </div>
            <button
              onClick={() => navigate("/inscription")}
              style={{ display: "flex", alignItems: "center", gap: 8, background: "#C4441A", color: "white", border: "none", padding: "14px 28px", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}
            >
              Inscrire mon établissement
              <IconArrowRight size={14} color="white" />
            </button>
          </div>

          {/* Retour */}
          <div style={{ marginTop: 40, textAlign: "center" }}>
            <button onClick={() => navigate("/destinations")}
              style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "none", border: "1.5px solid rgba(28,16,8,.15)", borderRadius: 10, padding: "12px 24px", cursor: "pointer", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, color: "#7A5A3A", transition: "all .25s" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "#C4441A"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(28,16,8,.15)"}
            >
              <IconArrow size={15} /> Toutes les destinations
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}